import GoogleDriveAPI from '@/apis/business/common/google-drive-api.js'
import { HttpStatusCode } from '@/common/constant'

export default {
  namespaced: true,

  state: {
    isLogin: false
  },

  mutations: {
    setIsLogin (state, param) {
      state.isLogin = param
    }
  },

  actions: {
    /**
     *
     * @param {*} context
     * @param {*} param
     * @returns link oauth google drive
     * @author BNDung
     */
    async login (context, param) {
      return await GoogleDriveAPI.getAsync('login').then((res) => {
        // context.commit('setDefaultAction', res.Data)
        if (res.Data && res.Code === HttpStatusCode.OK) {
          // CommonFn.downloadFileExcel(res.Data) } else {
          return res.Data
        }
      })
    },

    /**
     *
     * @param {*} context
     * @param {*} param
     * @returns link oauth google drive
     * @author BNDung
     */
    checkLogin (context, organizationID = '') {
      return new Promise((resolve, reject) => {
        GoogleDriveAPI.getAsync(`check-login?organizationID=${organizationID}`)
          .then((res) => {
            const isSuccess = res?.Data && res?.Code === HttpStatusCode.OK
            context.commit('setIsLogin', isSuccess)
            resolve(res?.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     *
     * @param {*} context
     * @param {*} param
     * @returns lưu data vào key cache
     * @author BNDung
     */
    async saveToken (context, authorCode) {
      return new Promise((resolve, reject) => {
        GoogleDriveAPI.postAsync('save-token', authorCode).then((res) => {
          if (res.Data && res.Code === HttpStatusCode.OK) {
            resolve(res.Data)
          } resolve(false)
        })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     *
     * @param {*} context
     * @param {*} param
     * @returns link oauth google drive
     * @author BNDung
     */
    getFiles (context, param) {
      return new Promise((resolve, reject) => {
        GoogleDriveAPI.getAsync('files')
          .then((res) => {
            if (res.Data && res.Code === HttpStatusCode.OK) {
              resolve(res.Data)
            }
            resolve(false)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     *
     * @param {*} context
     * @param {*} param
     * @returns lưu data vào key cache
     * @author BNDung
     */
    async destroyLink (context) {
      return await GoogleDriveAPI.getAsync('destroy-link').then((res) => {
        if (res.Data && res.Code === HttpStatusCode.OK) {
          return res.Data
        }
      })
    },

    /**
     *
     * @param {*} context
     * @param {*} param
     * @returns đồng bộ dữ liệu lên storage
     * @author BNDung
     */
    async syncStorage (context, params) {
      return await GoogleDriveAPI.postAsync('sync-storage', params).then((res) => {
        if (res.Data && res.Code === HttpStatusCode.OK) {
          return res.Data
        }
      })
    }
  }
}
